import styled from "styled-components";

export const PrintFooterWrapper = styled.section`
  display: none;
  position: absolute;
  align-items: center;
  bottom: 27px;
  justify-content: space-between;
  width: 95%;
  margin: 0 20px;
  font-weight: 500;
  @media print {
    display: flex;
  }
`;

export const LogoImage = styled.img`
  width: 150px;
  height: auto;
`;
